<template>
  <div class="relative min-h-screen overflow-hidden">
    <!-- Background Image with multiply blend effect -->
    <div class="fixed inset-0 -z-30">
      <img src="/assets/photo.jpg" alt="Background" class="w-full h-full object-cover opacity-50 bg-image-animate" />
    </div>
    
    <!-- Primary multiply blend overlay for rich color interaction -->
    <div class="fixed inset-0 -z-20 bg-gradient-to-br from-blue-900/70 via-blue-900/70 to-gray-900/70 mix-blend-multiply"></div>
    
    <!-- Secondary overlay for better text readability -->
    <div class="fixed inset-0 -z-10 bg-black/40 backdrop-blur-[2px]"></div>
    
    <!-- Additional dark base layer -->
    <div class="fixed inset-0 bg-gray-900" style="z-index: -40;"></div>
    
    <!-- Navigation Header Component -->
    <NavHeader :dealerName="accountData && accountData[0]?.name ? accountData[0].name : dealerName" />

    <!-- Main Content -->
    <div class="relative z-1 pt-8">
      <NotificationTemplateViewer />
    </div>
  </div>
</template>

<script>
import NotificationTemplateViewer from '@/components/NotificationTemplateViewer.vue'
import NavHeader from '@/components/NavHeader.vue'
import { mapState } from 'vuex'

export default {
  name: 'NotificationTemplates',
  components: {
    NotificationTemplateViewer,
    NavHeader
  },
  computed: {
    ...mapState(['accountData']),
    dealerName() {
      // Get dealer name from slug - convert slug format to display format
      const slug = this.$route.params.slug
      if (slug) {
        // Convert slug like "courtney-patterson-ford" to "Courtney Patterson Ford"
        return slug.split('-')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ')
      }
      return 'Dealership'
    }
  }
}
</script>

<style scoped>
/* Background image subtle zoom animation */
@keyframes subtle-zoom {
  0% { transform: scale(1); }
  50% { transform: scale(1.05); }
  100% { transform: scale(1); }
}

.bg-image-animate {
  animation: subtle-zoom 30s ease-in-out infinite;
}
</style>
